import { isValidPhoneNumber } from "libphonenumber-js";
import * as Yup from "yup";
const phoneRegExp = /^(\(\+\d{1,3}\))?\s?\d{10}$/;
const cnicRegExp = /^\d{5}-\d{7}-\d{1}$/;
const nameRegExp = /^[a-zA-Z]+( [a-zA-Z]+)*$/;
const ePhoneRegExp = /^\+?\d{1,3}\s?\d{10}$/;

export const announcementSchema = Yup.object().shape({
  title: Yup.string().required("Title is required"),
  shortDescription: Yup.string().required("Short description is required"),
  description: Yup.string().required("Description is required"),
  announcementSendTo: Yup.array(),
});

export const communityServiceSchema = Yup.object().shape({
  serviceCategoryName: Yup.string().required("Service Name is Required"),

  services: Yup.array()
    .of(
      Yup.object().shape({
        serviceName: Yup.string().required("Service Name is required"), // Ensure serviceName is not empty
        serviceCharges: Yup.number()
          .min(0, "Service Charges must be 0 or more") // Allow serviceCharges to be 0
          .required("Service Charges is required"),
      })
    )
    .min(1, "At least one service is required"), // Ensure at least one object is present in the array
});

export const changePasswordSchema = Yup.object().shape({
  currentPassword: Yup.string().required("Old Password is Required"),
  newPassword: Yup.string()
    .min(1, "New Password must be at least 1 characters")
    .required("New Password is Required"),
  confirmNewPassword: Yup.string()
    .min(1, "Confirm Password must be at least 1 characters")
    .required("Confirm Password is Required")
    .oneOf([Yup.ref("newPassword")], "Passwords must match"),
});

export const deleteAccountSchema = Yup.object().shape({
  password: Yup.string()
    // .min(5, "New Password must be at least 5 characters")
    .required("Password is Required"),
});

export const updateProfileSchema = Yup.object().shape({
  name: Yup.string()
    .required("Name is Required")
    .matches(nameRegExp, "Name must be a string"),
  email: Yup.string()
    .email("Email Address is not valid")
    .matches(/@[^.]*\./),
});

export const userFormWithoutAddressSchema = Yup.object().shape({
  name: Yup.string()
    .required("Name is equired")
    .matches(nameRegExp, "Name must be a string"),
  // countryCode: Yup.string().required("Required"),
  cellNo: Yup.string()
    .required("Required")
    .test("is-valid-phone", "Invalid phone number", (value) => {
      return isValidPhoneNumber(value || "");
    }),
  cnic: Yup.string()
    // .required("Required")
    .matches(
      cnicRegExp,
      "CNIC is not valid, must be in XXXXX-XXXXXXX-X format"
    ),
  // role: Yup.object().required("Required"),
  emergencyContactCellNo: Yup.string()
    .nullable()
    .test("is-valid-phone", "Invalid phone number", (value) => {
      if (!value) return true; // ✅ not required, skip if empty
      return isValidPhoneNumber(value);
    }),
  emergencyContactPersonName: Yup.string().matches(
    nameRegExp,
    "Emergency name must be a string"
  ),
});
export const userFormWithoutAddressOptionalSchema = Yup.object().shape({
  name: Yup.string().matches(nameRegExp, "Name must be a string"),
  // countryCode: Yup.string().required("Required"),
  cellNo: Yup.string()
    .nullable()
    .notRequired()
    .test("is-valid-phone", "Invalid phone number", (value) => {
      if (!value) return true; // Skip validation if empty/null
      return isValidPhoneNumber(value);
    }),
  cnic: Yup.string()
    // .required("Required")
    .matches(
      cnicRegExp,
      "CNIC is not valid, must be in XXXXX-XXXXXXX-X format"
    ),
  // role: Yup.object().required("Required"),
  emergencyContactCellNo: Yup.string()
    .nullable()
    .test("is-valid-phone", "Invalid phone number", (value) => {
      if (!value) return true; // ✅ not required, skip if empty
      return isValidPhoneNumber(value);
    }),
  emergencyContactPersonName: Yup.string().matches(
    nameRegExp,
    "Emergency name must be a string"
  ),
});

export const userFormWithAddressSchema = Yup.object().shape({
  name: Yup.string()
    .required("Required")
    .matches(nameRegExp, "Name must be a string"),
  // countryCode: Yup.string().required("Required"),
  cellNo: Yup.string()
    .required("Required")
    .test("is-valid-phone", "Invalid phone number", (value) => {
      return isValidPhoneNumber(value || "");
    }),
  cnic: Yup.string()
    // .required("Required")
    .matches(
      cnicRegExp,
      "CNIC is not valid, must be in XXXXX-XXXXXXX-X format"
    ),
  address: Yup.string(),
  // role: Yup.object().required("Required"),
  emergencyContactCellNo: Yup.string().test(
    "is-valid-phone",
    "Invalid phone number",
    (value) => {
      return isValidPhoneNumber(value || "");
    }
  ),
  emergencyContactPersonName: Yup.string().matches(
    nameRegExp,
    "Emergency name must be a string"
  ),
});

export const helpValidationSchema = Yup.object().shape({
  phoneNumber: Yup.string()
    .required("Required")
    .test("is-valid-phone", "Invalid phone number", (value) => {
      return isValidPhoneNumber(value || "");
    }),
  subject: Yup.object({
    label: Yup.string().required("Label is required"),
    value: Yup.number().required("Value is required"),
  }).required("Subject is required"),

  message: Yup.string()
    .required("Message is required")
    .max(1000, "Message can be at most 1000 characters"),
  attachment: Yup.string().nullable().notRequired(),
});

export const addBankAccountSchema = Yup.object({
  accountName: Yup.string().required("Nick Name is required"),
  accountNumber: Yup.string()
    .matches(/^[0-9]+$/, "Account Number must be digits only")
    .min(10, "Account Number must be at least 10 digits")
    .max(16, "Account Number must not exceed 16 digits")
    .required("Account Number is required"),

  bankName: Yup.object({
    label: Yup.string().required("Label is required"),
    value: Yup.number().required("Value is required"),
  }).required("Bank Name is required"),
  userBankAccount: Yup.object({
    label: Yup.string().required("Label is required"),
    value: Yup.string().required("Value is required"),
  }).nullable(true),
});
export const tPinSchema = Yup.object().shape({
  tPin: Yup.string()
    .required("tPin is required")
    .max(4, "tPin cannot be greater than 4 characters"),
});
export const addComplainModalSchema = Yup.object({
  communitySeriesDetail: Yup.object({
    label: Yup.string().required("Amenity label is required"),
    value: Yup.number().required("Amenity is required"),
  }).required("Amenity is required"),
  requestType: Yup.object({
    label: Yup.string().required("Request Type label is required"),
    value: Yup.number().required("Request Type is required"),
  }).required("Request Type is required"),
  complainTitle: Yup.string().required("Title is required"),
  complainDescription: Yup.string().required("Description is required"),
  DocumentList: Yup.array()
    .of(Yup.string().nullable()) // each element must be a string
    .notRequired(),
});

export const approvalsSchema = Yup.object({
  name: Yup.string()
    .required("Required")
    .matches(nameRegExp, "Name must be a string"),
  cellNo: Yup.string()
    .required("Required")
    .test("is-valid-phone", "Invalid Phone Number", (value) => {
      return isValidPhoneNumber(value || "");
    }),

  propertyTypeId: Yup.object().required("Required"),
  // role: Yup.object().required("Required"),
  communitySeriesDetailId: Yup.object().required("Required"),
});

export const joinApprovalEditSchema = Yup.object().shape({
  name: Yup.string()
    .required("Required")
    .matches(nameRegExp, "Name must be a string"),
  cellNo: Yup.string()
    .required("Required")
    .test("is-valid-phone", "Invalid Phone Number", (value) => {
      return isValidPhoneNumber(value || "");
    }),
  propertyTypeId: Yup.object().required("Required"),
  communitySeriesDetailId: Yup.object().required("Required"),
});

// schema/paymentCollectionSchema.js

export const paymentCollectionSchema = Yup.object().shape({
  receivedAmount: Yup.number()
  .required("Paid amount is required")
  .min(1, "Amount must be at least 1")
  .test(
    "max",
    "Received amount can't be greater than total dues",
    function (value) {
      const { totalCharges } = this.parent;
      if (!totalCharges || totalCharges <= 0) return true;
      return (value || 0) <= totalCharges;
    }
  ),
  transactionNote: Yup.string(),
  bankDocument: Yup.string()
    .trim()
    .when("paymentType", {
      is: 1,
      then: (schema) =>
        schema
          .required("Bank document is required")
          .min(1, "Bank document cannot be empty"),
      otherwise: (schema) => schema.notRequired(),
    }),
  paymentType: Yup.number(),
  selectedDues: Yup.array().min(1, "Select at least one bill"),
  totalCharges: Yup.number(),
});



export const receivePaymentCollectionSchema = Yup.object().shape({
  receivedAmount: Yup.number()
  .required("Paid amount is required")
  .min(1, "Amount must be at least 1")
  .test(
    "max",
    "Received amount can't be greater than total dues",
    function (value) {
      const { totalCharges } = this.parent;
      if (!totalCharges || totalCharges <= 0) return true;
      return (value || 0) <= totalCharges;
    }
  ),
accountCode: Yup.object({
    label: Yup.string().required("Label is required"),
    value: Yup.string().required("Value is required"), // or Yup.number() if value is numeric
  }).required("Account code is required"),
  
  selectedDues: Yup.array().min(1, "Select at least one bill"),
  totalCharges: Yup.number(),
});

export const addExpenseCategorySchema = Yup.object().shape({
  expenseName: Yup.string()
    .required("Expense Name Required")
    // .matches(nameRegExp, "Name must be a valid string"),
  });




export const addExpenseSchema =  Yup.object().shape({
  categoryCode: Yup.object({
    label: Yup.string().required("Label is required"),
    value: Yup.string().required("Value is required"), }).required("Expense Category is required"),// or Yup.number() if value is numeric   
 subCategoryCode: Yup.object({
    label: Yup.string().required("Label is required"),
    value: Yup.string().required("Value is required"),// or Yup.number() if value is numeric   
  }).required("Expense Sub Category is required"),
  accountCode:Yup.object({
    label:Yup.string().required("Label is required"),
    value:Yup.string().required("Value is required"),}).required("Payment Account is required")
    ,
  amount: Yup.number().required("Expense Amount is required").min(1, "Amount must be greater than zero"),
  description: Yup.string().required("Description is required"),
});    

export const openingBalanceSchema = Yup.object().shape({
  openingBalance: Yup.number()
    .required("Opening Balance is required").min(0, "Opening Balance cannot be negative"),
});

export const createBankWithOpeningBalanceSchema = Yup.object().shape({
  openingBalanceBank:Yup.number().required("Opening Balance is required").min(0,"Opening Balance is required"),
bankName:Yup.string().required("Bank Name is Required")
});
export const transferFundSchema = Yup.object().shape({
  fromAccountCode: Yup.object({
    label: Yup.string().required("Label is required"),
    value: Yup.string().required("Value is required"),
    balance: Yup.number().required("Balance is required"),
  }).required("From Account Code is required"),

  toAccountCode: Yup.object({
    label: Yup.string().required("Label is required"),
    value: Yup.string().required("Value is required"),
    balance: Yup.number().required("Balance is required"),
  }).required("To Account Code is required"),

  amount: Yup.number()
    .required("Amount is required")
    .test(
      "max-balance",
      "Amount cannot be greater than available balance",
      function (value) {
        const fromBalance = this.parent?.fromAccountCode?.balance;
        if (!fromBalance || !value) return true; // skip if not filled yet
        return value <= fromBalance;
      }
    ).min(1,"Amount should be greater than 0"),
});

export const subscriptionSchema = Yup.object({
  noOfUnits: Yup.number().required(),
  mainUnits: Yup.number()
    .required("units is required")
  .test(
  'not-less-than-previous',
  'Main units cannot be less than the previously selected number of units',
  function (value) {
    const previousUnits = this.options.context?.previousUnits; // passed via validate({ context: { previousUnits } })
    if (previousUnits === undefined || value === undefined) return true;
    return value >= previousUnits; 
  }
),
  seriesCount: Yup.number().required(),
});